import { makeStyles } from '@material-ui/core';
import { ThemeInstance } from 'configs/theme';

import styled from 'shared/utils/styled';

export const Container = styled('div')(() => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  paddingLeft: 4,
  paddingRight: 10,
  background: '#fff',
  border: '1px solid #EAEDF2',
}));

export const useStyles = makeStyles((theme: ThemeInstance) => ({
  input: {
    height: 'auto',
    padding: 6,
    fontFamily: 'NeoSansStd !important',
  },
  icon: {
    marginLeft: 10,
    fontSize: '1.4rem',
    color: theme.custom.darkBlue,
    transform: 'scale(-1, 1)',
  },
  inputRoot: {
    width: '100%',
  },
}));
